import { BaseCaller } from './api';


export default class ReportApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    racesGeneral(data: { init: string; end: string; branch: number; driver: any, report: number }) {

        // const driverIds = data.driver.join(','); // Convierte el arreglo de IDs en una cadena separada por comas

        let driverParams = '';
        if (data.report === 5 && Array.isArray(data.driver)) {
            driverParams = data.driver.map((id: number) => `driverIds=${id}`).join('&');
            driverParams = driverParams + '&driverId=0';
        } else {
            // Si driver es array, toma el primer elemento; si no, lo usa directamente
            const driverId = Array.isArray(data.driver) ? data.driver[0] : data.driver;
            driverParams = `driverId=${driverId}`;
        }

        return this.caller.get(
            `report/races?init=${data.init}&end=${data.end}&${driverParams}&branchId=${data.branch}&reportId=${data.report}`
        );

        //     return this.caller.get(`report/races?init=${data.init}&end=${data.end}&driverId=${data.driver}&branchId=${data.branch}&reportId=${data.report}`);
    }

    reportList() {
        return this.caller.get('report/adminReports');
    }

    reportAssists(data: { init: string; end: string;driver: any, report: number }) {

        let driverParams = '';
        if (data.report  && Array.isArray(data.driver)) {
            driverParams = data.driver.map((id: number) => `personalIds=${id}`).join('&');
        } else {
            // Si driver es array, toma el primer elemento; si no, lo usa directamente
            const driverId = Array.isArray(data.driver) ? data.driver[0] : data.driver;
            driverParams = `personalIds=${driverId}`;
        }

        // Petición directa al endpoint externo (no usa el caller de Taxio)
        const url = `https://ping.matizsae.com.py/tag/rest/pedidos-movil/marcacion/reporte?init=${data.init}&end=${data.end}&${driverParams}`;

        return fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/pdf'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.blob(); // Para PDFs, retornamos blob en lugar de JSON
        })
        .catch(error => {
            console.error('Error fetching report assists:', error);
            throw error;
        });
    }

}



// WEBPACK FOOTER //
// ./src/api/report-api.ts